import React from 'react';
import { Route, Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, adminOnly = false }) => {
    const user = JSON.parse(localStorage.getItem('user'));

    if (!user) {
        return <Navigate to="/login" />;
    }

    if (adminOnly && !user.isAdmin) {
        return <Navigate to="/dashboard" />;
    }

    return children;
};

export default PrivateRoute;
